// ChartComponent.js

import React, { useEffect, useRef, useState } from 'react';
import Highcharts from 'highcharts/highstock';


const DashboardCust = ({ graphData }) => {
    const chartContainerRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [stopLoss, setStopLoss] = useState('');
    const [takeProfit, setTakeProfit] = useState('');
    const [annotations, setAnnotations] = useState([]);

    const [selectedCurrency, setSelectedCurrency] = useState('');
    const currencySymbols = ['AAPL', 'DJI', 'DXY', 'NDJ']; // Add more currency symbols as needed
    const [showModalCurr, setShowModalCurr] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState('');

    useEffect(() => {
        if (!chartContainerRef.current) return;


        console.log(graphData.params.graphData)
        const fetchData = async () => {
            const response = await fetch('https://demo-live-data.highcharts.com/aapl-ohlcv.json');
            const data = await response.json();

            const ohlc = [];
            const volume = [];

            for (let i = 0; i < data.length; i += 1) {
                ohlc.push([
                    data[i][0], // the date
                    data[i][1], // open
                    data[i][2], // high
                    data[i][3], // low
                    data[i][4], // close
                ]);

                volume.push([
                    data[i][0], // the date
                    data[i][5], // the volume
                ]);
            }



            const chart = Highcharts.stockChart(chartContainerRef.current, {
                chart: {
                    backgroundColor: '#2d2d30',
                },
                // Existing chart options...
                rangeSelector: {
                    selected: 1,
                },
                title: {
                    text: 'AAPL Stock Price',
                    style: {
                        color: 'purple', // Set the title color
                    },
                },
                yAxis: [
                    {
                        labels: {
                            align: 'left',
                            style: {
                                color: 'yellow', // Set the Y-axis label color
                            },
                        },
                        height: '80%',
                        resize: {
                            enabled: true,
                        },
                    },
                    {
                        labels: {
                            align: 'left',
                        },
                        top: '80%',
                        height: '20%',
                        offset: 0,
                    },
                ],
                plotOptions: {
                    candlestick: {
                        color: graphData.params.graphData?.dropdown1 === 'Red and Blue' ? 'red' : graphData.params.graphData?.dropdown1 === 'Blue and Pink' ? 'blue' : '#a6f703',
                        upColor: graphData.params.graphData?.dropdown1 === 'Red and Blue' ? 'yellow' : graphData.params.graphData?.dropdown1 === 'Blue and Pink' ? 'pink' : '#0382ca',
                    },
                },
                tooltip: {
                    shape: 'square',
                    headerShape: 'callout',
                    borderWidth: 0,
                    shadow: false,
                    positioner: function (width, height, point) {
                        var chart = this.chart,
                            position;

                        if (point.isHeader) {
                            position = {
                                x: Math.max(
                                    chart.plotLeft,
                                    Math.min(
                                        point.plotX + chart.plotLeft - width / 2,
                                        chart.chartWidth - width - chart.marginRight
                                    )
                                ),
                                y: point.plotY,
                            };
                        } else {
                            position = {
                                x: chart.plotLeft,
                                y: chart.plotTop, // Adjust this if needed
                            };
                        }

                        return position;
                    },
                },

                series: [
                    // Existing series...
                    {
                        type: 'candlestick',
                        // type: 'ohlc',
                        id: 'aapl-ohlc',
                        name: 'AAPL Stock Price',
                        data: ohlc,
                    },
                    {
                        type: 'column',
                        id: 'aapl-volume',
                        name: 'AAPL Volume',
                        data: volume,
                        yAxis: 1,
                    },

                    // Annotations for Buy and Sell
                    {
                        type: 'flags',
                        data: annotations,
                        onSeries: 'aapl-ohlc', // Attach to the OHLC series
                        shape: 'circlepin', // You can use different shapes
                        width: 16,
                        fillColor: 'green', // Customize the color
                        style: {
                            color: 'white', // Text color
                        },
                    },
                ],


                // Other existing chart options...
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 800,
                            },
                            chartOptions: {
                                rangeSelector: {
                                    inputEnabled: false,
                                },
                            },
                        },
                    ],
                },
            });
            return () => {
                // Destroy the chart when the component unmounts
                if (chart) {
                    chart.destroy();
                }
            };
        }


        fetchData()

    }, [graphData]);

    return <div ref={chartContainerRef} className="chart-container" />;
};

export default DashboardCust;

